import './button.style.scss';

type IButtonProps = {
  text: string;
  type?: 'primary' | 'secondary' | 'link';
  icon?: React.ReactNode;
  style?: React.CSSProperties;
  onClick?: () => any;
  buttonType?: 'button' | 'submit' | 'reset';
  isLoading?: boolean;
  loadingText?: string;
  disabled?: boolean;
  isLeft?: boolean;
  className?: string;
};

const Button = ({
  text,
  type = 'primary',
  icon,
  style,
  onClick,
  buttonType = 'button',
  isLoading = false,
  loadingText = 'Processing',
  disabled = false,
  isLeft = true,
  className,
}: IButtonProps) => {
  const isDisabled = disabled || isLoading;

  return (
    <button
      type={buttonType}
      className={`button  ${type} ${className}`}
      style={style}
      onClick={onClick && !isDisabled ? onClick : undefined}
      disabled={isDisabled}
      aria-busy={isLoading || undefined}
    >
      {isLeft && icon}
      {isLoading ? loadingText : text}
      {!isLeft && icon}
    </button>
  );
};

export default Button;
